export enum SortOrder {
    SortByFirst = 1,
    SortBySecond = -1,
    NoSort = 0
}
